












import Vue, { PropOptions } from 'vue';

type FaqItemProps = Blok & {
  title: string;
  content: string;
  fromExpName: string;
}

type FaqProps = Blok & {
  title: string;
  faqRows: FaqItemProps[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<FaqProps>,
    activeExpName: {
      type: String,
      default: '',
    },
  },
  computed: {
    faqItems(): Blok[] {
      return this.blok.faqRows.filter(
        (faqRow) => faqRow.fromExpName === this.activeExpName || !faqRow.fromExpName
      );
    },
  }
});
